import { Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { DetailedModalComponent } from '../../modals/detailed-modal/detailed-modal.component';
import { ZiroFormStateService } from '../../forms/ziro-form-state.service';
import { ZiroFormConfig } from '../../forms/ziro-forms-models';
import { ModalBodyClass } from '../../modals/modal-body';
import { ZiroIcons } from '../../shared/models/ziro-icons.enum';
import { Observable, throwError } from 'rxjs';
import { Global360ViewContext } from '../../shared/contexts/global-360-view.context';
import { UserDetailUiContext } from '../shared/contexts/user-detail-ui.context';
import { Global360View, VoicemailRef } from '../../shared/models/generated/ziroModels';
import { VoicemailComponent } from '../cisco/voicemail/voicemail.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'ziro-voicemail-detailed-modal',
  templateUrl: './voicemail-detailed-modal.component.html',
  styleUrls: ['./voicemail-detailed-modal.component.scss'],
  providers: [Global360ViewContext, UserDetailUiContext],
  standalone: false,
})
export class VoicemailDetailedModalComponent extends ModalBodyClass implements OnInit {
  private modalComponent = inject<DetailedModalComponent<any>>(DetailedModalComponent);
  private ngbActiveModal = inject(NgbActiveModal);
  protected _ziroFormStateService: ZiroFormStateService;

  @ViewChild(VoicemailComponent) voicemail: VoicemailComponent;
  @ViewChild('errorTemplate') errorTemplate: TemplateRef<any>;
  areFormsValid = true;
  ziroIcons = ZiroIcons;
  modalProperties: any;
  voicemailRef: VoicemailRef;
  global360View: Global360View;
  isLoading = true;

  cssClass = {
    margin: '100px auto',
  };
  private _isVoicemailSaved = false;

  formConfig = {
    fields: {},
  } as ZiroFormConfig;

  ngOnInit(): void {
    this.modalProperties = this.modalComponent.modalViewProperties;
  }

  isFormValid(): boolean {
    this.areFormsValid = this.voicemail.voicemailForm.isFormValid();
    return this.voicemail.voicemailForm.isFormValid();
  }

  onVoicemailRefUpdated(vmRef: VoicemailRef): void {
    this.voicemailRef = vmRef;
    this._isVoicemailSaved = true;
  }

  submit(): Observable<VoicemailRef | void> {
    return this.voicemail.voicemailForm.handleSaveClick().pipe(
      catchError((error) => {
        if (this._isVoicemailSaved) {
          // If the voicemail save worked but one of the other calls failed, close the modal to take us back to a working state.
          this.ngbActiveModal.close(this.voicemailRef);
        }
        return throwError(() => error);
      }),
    );
  }

  delete(): Observable<void> {
    const modalObs$ = new Observable<void>(() => {
      this.voicemail.voicemailForm.handleDeleteClick();
    });
    return modalObs$.pipe();
  }

  cancel(): void {
    this.ngbActiveModal.close({ isCancelClicked: true });
  }

  setLoading($event: boolean): void {
    this.isLoading = $event;
    this._ziroFormStateService.isFormLoading.next(this.isLoading);
  }
}
